import { render } from "./TestTypeDot.vue?vue&type=template&id=ef42c002"
import script from "./TestTypeDot.vue?vue&type=script&lang=js"
export * from "./TestTypeDot.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__